export default "__VITE_ASSET__C$wIYm1G__"